import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

/**
 * DocumentTypeBadge — плашка вида итогового документа программы обучения перед её названием
 * (training-program-picker; комментарий заказчицы к ТЗ, п.4.5: «документ в виде значка, небольшой
 * цветной плашки… Удостоверение/Диплом/Протокол/Свидетельство. Цвета в палитре кабинета, неброские,
 * но отличающиеся»). Четыре вида — свои токены `--doc-*`, не статусные цвета: на тех же экранах
 * статусы и светофор. Вид читается по тексту, не только по цвету.
 */
export type DocumentTypeKind = 'cert' | 'diploma' | 'protocol' | 'svid'

const KIND_CLASSES: Record<DocumentTypeKind, string> = {
  cert: 'bg-doc-cert-bg text-doc-cert',
  diploma: 'bg-doc-diploma-bg text-doc-diploma',
  protocol: 'bg-doc-protocol-bg text-doc-protocol',
  svid: 'bg-doc-svid-bg text-doc-svid',
}

export interface DocumentTypeBadgeProps extends HTMLAttributes<HTMLSpanElement> {
  kind: DocumentTypeKind
}

export const DocumentTypeBadge = forwardRef<HTMLSpanElement, DocumentTypeBadgeProps>(
  ({ kind, className, children, ...props }, ref) => (
    <span
      ref={ref}
      className={cn(
        'inline-flex shrink-0 items-center whitespace-nowrap rounded-7 px-2 py-0.5 align-middle text-12 font-medium',
        KIND_CLASSES[kind],
        className,
      )}
      {...props}
    >
      {children}
    </span>
  ),
)
DocumentTypeBadge.displayName = 'DocumentTypeBadge'
